import React from 'react';
import LinkProvider from '../../../../CommonComponents/LinkProvider/LinkProvider';
import { roundUptoDigits } from '../../../../utils/helper';
import './RefundDetails.scss';
// import ErrorOutlineOutlined from '../../../../../static/assets/svg/mui-icons/ErrorOutlineOutlined.svg';

function copyScCode(props) {
  const {
    setToastMessage,
    triggerDtmOnClick,
    triggerTracking,
    dataLocale: {
      STORE_CREDIT_CODE_HAS_BEEN_COPIED,
      COPY_NOT_SUPPORTED_TEXT,
      COPY_NOT_SUPPORTED_OR_BLOCKED,
    },
  } = props;
  if (triggerDtmOnClick && typeof triggerDtmOnClick === 'function') {
    triggerDtmOnClick('Copy Code');
  }
  if (triggerTracking && typeof triggerTracking === 'function') {
    triggerTracking({ eventLev: 'copy code' });
  }
  const copyCode = document.querySelector('.sc-code');
  copyCode.select();
  try {
    const successful = document.execCommand('copy');
    const msg = successful ? STORE_CREDIT_CODE_HAS_BEEN_COPIED : COPY_NOT_SUPPORTED_TEXT;
    setToastMessage({ message: msg, timeout: 5000 });
  } catch (err) {
    setToastMessage({ message: COPY_NOT_SUPPORTED_OR_BLOCKED, timeout: 5000 });
  }
}

function RefundDetails(props) {
  const {
    creditTitle,
    additionalInfo,
    hasMultipleRefunds,
    refundDetails,
    fullRefundDetails,
    storeCreditCode,
    dataLocale,
    triggerTracking,
  } = props;
  const { CURRENCY_SYMBOL, LK_CASH_PLUS, LK_CASH, STORE_CREDIT, COPY_CODE } = dataLocale; // PAYU
  const { partialRefundedAmount, refundedLkCash, refundedLkCashPlus, storeCreditAmount } =
    refundDetails;
  const totalRefundedAmount = partialRefundedAmount || refundedLkCash + refundedLkCashPlus;
  return (
    <div className="pd-t20 pd-b20 pd-l10 pd-r10 bg-color_white mr-t10 mr-b17 text-center roboto">
      <div className="fs18 fw600 margin-b17 display-flex justify-content-between">
        <div className="fw500 fsp14 lh-16 mr-b12 text-color_dark_grey">{creditTitle}</div>
        {hasMultipleRefunds && (
          <div>
            {CURRENCY_SYMBOL}
            {roundUptoDigits(totalRefundedAmount, 0)}
          </div>
        )}
        {additionalInfo &&
          !hasMultipleRefunds &&
          Boolean(additionalInfo && additionalInfo.link) && (
            <LinkProvider
              className="text-color_primary mr-t10 text-uppercase fw500 fsp12 lh-14 block"
              to={additionalInfo.link.url}
              onClick={() => triggerTracking({ eventLev: additionalInfo.link.text })}
            >
              {additionalInfo.link.text}
            </LinkProvider>
          )}
      </div>
      {/* {!refundDetails.partialRefundedAmount && (refundDetails.refundedLkCash > 0 || refundDetails.refundedLkCashPlus > 0) && <div className="fw500 fsp32 lh-20 text-color_grey_black mr-t10 mr-b20">{CURRENCY_SYMBOL}{refundDetails.refundedLkCash + refundDetails.refundedLkCashPlus}</div>}
            {refundDetails.partialRefundedAmount > 0 && <div className="fw500 fsp32 lh-20 text-color_grey_black mr-t10 mr-b20">{CURRENCY_SYMBOL}{refundDetails.partialRefundedAmount}</div>} */}
      {/* <div className="fw500 fsp32 lh-20 text-color_grey_black mr-t10 mr-b20">{CURRENCY_SYMBOL}{roundUptoDigits(totalRefundedAmount, 0)}</div> */}
      {hasMultipleRefunds && (
        <div className="fw500 fsp14 fs16 lh-16 mr-b5 mr-t20 text-color_dark_grey">
          {fullRefundDetails &&
            fullRefundDetails.length &&
            fullRefundDetails.map((detail, index) => {
              return detail.refundMethod !== 'storecredit' ? (
                <div key={index} className="display-flex justify-space-between pd-t5 pd-b5">
                  <div className="text-color_pale_black text-capitalize fw500">
                    {detail.refundMethodLabel || detail.refundMethod}
                  </div>
                  <div className="fw500">
                    {CURRENCY_SYMBOL}
                    {roundUptoDigits(detail.refundAmount, 0)}
                  </div>
                </div>
              ) : null;
            })}
          {storeCreditAmount > 0 && (
            <div>
              <div className="addInfo padding-t5 display-flex justify-space-between pd-t10 pd-b10">
                <div className="text-color_pale_black fw500">{STORE_CREDIT}</div>
                <div className="fw500">
                  {CURRENCY_SYMBOL}
                  {storeCreditAmount}
                </div>
              </div>
              {/* {
                            storeCreditCode &&
                            <div className="bora-4 display-flex align-items-center justify-space-between pd-10 mr-b10 sc-code-border">
                                <div className="display-flex">
                                    <input type="text" readOnly className="border-none text-color_pale_black fw500 fsp14 sc-code inline-block" defaultValue={storeCreditCode} />
                                    <div className="fw500 fsp14 text-topaz" data-testid="copySC" onClick={() => copyScCode(props)}><img src="https://static.lenskart.com/media/mobile/images/copy.png" alt="copy code" className="padding-r5 pd-r5 text-topaz" />Copy</div>
                                </div>
                                <div>{CURRENCY_SYMBOL}{storeCreditAmount}</div>
                            </div>
                        } */}
              {storeCreditCode && (
                <div className="mr-t10 multi-refund-sc background-f5 margin-t10 margin-b10">
                  <div className="fs14 fw500 text-color-grey text-uppercase margin-b7 display-flex justify-content-between">
                    <div>{additionalInfo.label}</div>
                    <div>{creditTitle}</div>
                  </div>
                  <div className="fs16 fw500 margin-t4 display-flex justify-content-between">
                    {Boolean(storeCreditCode) && (
                      <div className="fs14 display-flex align-items-center border-dull_orange">
                        <input
                          readOnly
                          className="border-none text-center fw500 fsp20 lh-23 mr-t10 mr-b10 pd-t8 pd-b8 pd-l16 pd-r16 sc-code text-dull_orange bora-4 inline-block background-f5"
                          defaultValue={storeCreditCode}
                          type="text"
                        />
                        <div
                          className="text-color-primary fw500 cursor-pointer fsp12 lh-14 mr-b15 margin-r20"
                          data-testid="copySC"
                          onClick={() => copyScCode(props)}
                        >
                          <img
                            alt="copy code"
                            className="padding-r5 pd-r5 text-topaz"
                            src="https://static.lenskart.com/media/mobile/images/copy.png"
                          />
                          {COPY_CODE}
                        </div>
                      </div>
                    )}
                    <div className="fs14 lh-20 text-color_grey_black mr-t10 mr-b20">
                      {CURRENCY_SYMBOL}
                      {roundUptoDigits(storeCreditAmount, 0)}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
          {refundedLkCash > 0 && (
            <div className="addInfo padding-t5 display-flex justify-space-between pd-t5 pd-b5">
              <div className="text-color_pale_black fw500">{LK_CASH}</div>
              <div className="fw500">
                {CURRENCY_SYMBOL}
                {refundedLkCash}
              </div>
            </div>
          )}
          {refundedLkCashPlus > 0 && (
            <div className="addInfo padding-t5 display-flex justify-space-between pd-t5 pd-b5">
              <div className="text-color_pale_black fw500">{LK_CASH_PLUS}</div>
              <div className="fw500">
                {CURRENCY_SYMBOL}
                {refundedLkCashPlus}
              </div>
            </div>
          )}
        </div>
      )}
      {additionalInfo && !hasMultipleRefunds && (
        <div className="mr-t10 addInfo">
          <div className="fs14 fw500 margin-t10 text-color-grey text-uppercase margin-b7 display-flex justify-content-between">
            <div>{creditTitle}</div>
            <div>{additionalInfo.label}</div>
          </div>
          <div className="fs16 fw500 margin-t4 display-flex justify-content-between">
            <div className="fw600 fs18 lh-20 text-color_grey_black mr-t10 mr-b20">
              {CURRENCY_SYMBOL}
              {roundUptoDigits(totalRefundedAmount, 0)}
            </div>
            {Boolean(storeCreditCode) && (
              <div className="fs14">
                <input
                  readOnly
                  className="text-center fw500 fsp20 lh-23 mr-t10 mr-b10 pd-t8 pd-b8 pd-l16 pd-r16 sc-code border-dull_orange text-dull_orange bora-4 inline-block"
                  defaultValue={storeCreditCode}
                  type="text"
                />
                <div
                  className="text-color-primary fw500 cursor-pointer fsp12 lh-14 mr-b15"
                  data-testid="copySC"
                  onClick={() => copyScCode(props)}
                >
                  <img
                    alt="copy code"
                    className="padding-r5 pd-r5 text-topaz"
                    src="https://static.lenskart.com/media/mobile/images/copy.png"
                  />
                  {COPY_CODE}
                </div>
              </div>
            )}
          </div>
          <div className="display-flex bora-4 bg-cyan margin-t30" style={{ padding: '8px 16px' }}>
            <img
              alt="error-outline"
              className="margin-r12"
              src="https://static.lenskart.com/media/desktop/img/myorder/ErrorOutlineOutlined.svg"
            />
            <div>
              <p className="fs14 text-left">
                {Boolean(additionalInfo && additionalInfo.desc) &&
                  additionalInfo.desc.map((info, index) => (
                    <span key={`desc-${index}`} className="lh-16 fsp12 text-color_dull_black">
                      {info}{' '}
                    </span>
                  ))}
              </p>
            </div>
          </div>
          {/* {Boolean(storeCreditCode) && <React.Fragment>
                        <input type="text" readOnly className="text-center fw700 fsp20 lh-23 mr-t10 mr-b10 pd-t8 pd-b8 pd-l16 pd-r16 sc-code border-dull_orange text-dull_orange bora-4 inline-block" defaultValue={storeCreditCode} />
                        <div data-testid="copySC" className="text-topaz fw500 fsp12 lh-14 mr-b15" onClick={() => copyScCode(props)}>{COPY_CODE}</div>
                    </React.Fragment>} */}
        </div>
      )}
    </div>
  );
}

export default RefundDetails;
